import { render, staticRenderFns } from "./API.vue?vue&type=template&id=1a5b8b6a&scoped=true&"
import script from "./API.vue?vue&type=script&lang=ts&"
export * from "./API.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b8b6a",
  null
  
)

export default component.exports